import React from 'react';

const OtterLogo: React.FC<{ className?: string }> = ({ className = "w-8 h-8" }) => {
  return (
    <svg
      viewBox="0 0 64 64"
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Body */}
      <path
        d="M32 52c12.15 0 22-9.85 22-22S44.15 8 32 8 10 17.85 10 30s9.85 22 22 22z"
        fill="currentColor"
        fillOpacity="0.1"
      />
      {/* Head */}
      <path
        d="M32 44c7.732 0 14-6.268 14-14S39.732 16 32 16s-14 6.268-14 14 6.268 14 14 14z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      {/* Eyes */}
      <circle cx="28" cy="28" r="2" fill="currentColor" />
      <circle cx="36" cy="28" r="2" fill="currentColor" />
      {/* Nose */}
      <path
        d="M32 32a2 2 0 100-4 2 2 0 000 4z"
        fill="currentColor"
      />
      {/* Whiskers */}
      <path
        d="M24 30l-6 2M24 32l-6-2M40 30l6 2M40 32l6-2"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      {/* Ears */}
      <path
        d="M26 20c-2-2-4-2-5-1.5M38 20c2-2 4-2 5-1.5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      {/* Tech Elements */}
      <path
        d="M15 30a17 17 0 0134 0"
        stroke="currentColor"
        strokeWidth="1"
        strokeDasharray="2 3"
      />
      <path
        d="M20 40a12 12 0 0124 0"
        stroke="currentColor"
        strokeWidth="1"
        strokeDasharray="2 3"
      />
    </svg>
  );
};

export default OtterLogo;